import { transactionStatusTypes } from 'features/BookingDetails/types'
import moment from 'moment'

function getStatusColor(status) {
  const activeColor = '#428BE1'
  const goodColor = '#0FC317'
  const badColor = '#E45A5A'

  switch (transactionStatusTypes[status]) {
    case transactionStatusTypes.Cancelled:
      return badColor

    case transactionStatusTypes.NoShow:
      return badColor

    case transactionStatusTypes.InUse:
      return activeColor

    case transactionStatusTypes.Completed:
      return goodColor

    case transactionStatusTypes.Confirmed:
      return goodColor

    default:
      return '#b1aeae'
  }
}

const BookingStatusPill = ({ status, bookingDate }) => {
  const uiStatus = transactionStatusTypes?.[status]

  if (transactionStatusTypes[status]) {
    return (
      <span
        style={{
          backgroundColor: getStatusColor(status),
          color: 'white',
          marginLeft: 10,
          fontWeight: 500,
          fontSize: 13,
          padding: '2px 7px',
          borderRadius: 2,
          textTransform: 'uppercase'
        }}
      >
        {console.log({ uiStatus, bookingDate })}
        {uiStatus === 'Booked' && moment(bookingDate).isBefore(moment())
          ? 'Completed'
          : uiStatus}
      </span>
    )
  }

  return null
}

export default BookingStatusPill
